export enum EItemDropBehavior {
  cantDrop = 0,
  asLastChildItem = 1,
  afterItem = 2,
  asFixedHeader = 3,
  asFixedFooter = 4,
  asLayoutHeader = 5,
  asLayoutFooter = 6,
  asLayoutLeft = 7,
  asLayoutRight = 8,
  asPageHeader = 9,
  asPageFooter = 10
}
